// extracted by mini-css-extract-plugin
export default {"container":"Mh4QQ","label":"jUtdF","tooltipContainer":"SiF6b","tooltipHeader":"lB90n","tooltipItems":"c8aRm","tooltipItem":"Tsp1X","highlighted":"Q0JB6"};